import React, { useMemo } from 'react'
import { ScrollView } from 'react-native-gesture-handler'
import { View } from 'react-native'
import moment from 'moment-timezone'
import styled, { useTheme } from 'styled-components/native'

import { DATE_FORMAT } from 'APP/Redux/AppointmentBookingRedux'
import Typography from 'APP/Converse/Typography'

import DayTabWithAvailability from '../common/dayTabWithAvailability'

import { AvailabilitiesExists } from '../utils/types'
import { createDays, dayToReadableText } from '../utils/helpers'

const TitleWrapper = styled.View`
  background-color: ${({ theme }) => theme.colors.elementsBg};
  padding-top: ${({ theme }) => theme.metrics.baseMargin}px;
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin}px;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

interface Props {
  dateFrom: moment.Moment
  dateUntil: moment.Moment
  selectedDate: moment.Moment
  onSelect: (day: moment.Moment) => void
  availabilitiesExists: Readonly<AvailabilitiesExists>
}

export const DayPicker: React.FC<Props> = ({
  dateFrom,
  dateUntil,
  onSelect,
  selectedDate,
  availabilitiesExists,
}) => {
  const theme = useTheme()
  const days = useMemo(() => createDays(dateFrom, dateUntil), [dateFrom, dateUntil])

  const daysButtons = days.map((day) => {
    const formattedSelectedDay = day.format(DATE_FORMAT)
    const hasAvailabilities = availabilitiesExists[formattedSelectedDay] ?? false
    return (
      <DayTabWithAvailability
        key={formattedSelectedDay}
        day={day}
        onSelect={() => onSelect(day)}
        selected={day.isSame(selectedDate, 'day')}
        hasAvailabilities={hasAvailabilities}
      />
    )
  })

  return (
    <View>
      <TitleWrapper>
        <Typography variant="h3" align="center">
          {`${dayToReadableText(selectedDate)}, ${selectedDate.format('MMMM D')}`}
        </Typography>
      </TitleWrapper>
      <ScrollView
        horizontal
        centerContent
        contentContainerStyle={{
          flexGrow: 1,
          justifyContent: 'center',
          paddingTop: theme.metrics.baseMargin / 2,
          paddingBottom: 0,
          paddingHorizontal: theme.metrics.baseMargin * 1.5,
        }}
      >
        {daysButtons}
      </ScrollView>
    </View>
  )
}

export default DayPicker
